// @ts-nocheck
import React from 'react';
import PrintableWorksheetsView from './view';
import PrintableWorksheetsProvider from './state';
import AppMediaProvider from '../baseStyles/AppMediaProvider';
import { initGlobalCachePrevention } from '../utils/preventBrowserCache';

export enum WorksheetsEnvironment {
    TEACHER_DASHBOARD = 'TEACHER_DASHBOARD', 
    STUDENT_DASHBOARD = 'STUDENT_DASHBOARD'
}

window.school_ui = {
    ...(window.school_ui || {})
};
interface IPrintableWorksheetsProps {
    userId: string;
    onboardingGrade: string;
    worksheetsEnvironment: WorksheetsEnvironment | null;
    subject: string;
}

const PrintableWorksheets: React.FC<IPrintableWorksheetsProps> = (props) => {

    const subjectCodeFromSession = sessionStorage.getItem('worksheet_subject_code');
    const isStudentDashboard = props?.worksheetsEnvironment === WorksheetsEnvironment.STUDENT_DASHBOARD;
    const propsToPass = (subjectCodeFromSession && isStudentDashboard) ? ({ ...props, subject: subjectCodeFromSession, explicitSubject: true }) : props;

    return (
        <AppMediaProvider>
            <PrintableWorksheetsProvider {...propsToPass}>
                <PrintableWorksheetsView/>
            </PrintableWorksheetsProvider>
        </AppMediaProvider>
    )
}
// Initialize global cache prevention
initGlobalCachePrevention();
const container = document.getElementById('printable-worksheets-container-wrap');

if(container){
    window.school_ui.printableWorksheets = ({userId, onboardingGrade, worksheetsEnvironment, subject, ...props}: IPrintableWorksheetsProps): void => {
        import('react-dom/client').then(({createRoot}) => {
            const root = createRoot(container);
            root.render(
                <PrintableWorksheets 
                    userId = {userId}
                    onboardingGrade={onboardingGrade}
                    worksheetsEnvironment={worksheetsEnvironment}
                    subject={subject}
                    {...props}
                />
            );
        })
    }
}

export default PrintableWorksheets;